import { render, staticRenderFns } from "./settingPrintSplit.vue?vue&type=template&id=6dddfc1a&scoped=true"
import script from "./settingPrintSplit.vue?vue&type=script&lang=js"
export * from "./settingPrintSplit.vue?vue&type=script&lang=js"
import style0 from "./settingPrintSplit.vue?vue&type=style&index=0&id=6dddfc1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dddfc1a",
  null
  
)

export default component.exports